export const ErrorBoundarySessionStorageKey = 'lxs:globalErrorCode';
